import { postFoDetailWithRetry } from './foDetailRequest';

/**
 * POST with empty JSON body - returns all smart cards.
 */
export async function getSmartCardsData() {
  const data = await postFoDetailWithRetry('/user/fo-detail');
  return data;
}

/**
 * POST with limit parameter - returns limited smart cards for home page.
 * @param {number} limit - Maximum number of cards to return (default 3)
 */
export async function getSmartCardsDataLimited(limit = 3) {
  return postFoDetailWithRetry(`/user/fo-detail/limited?limit=${limit}`);
}
